var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultimedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.142,
    height: 68.142,
    viewBox: "0 0 68.142 68.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1630",
    "data-name": "Rectangle 1630",
    width: 68.142,
    height: 68.142,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multimedia",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60333",
    "data-name": "Path 60333",
    d: "M67.292,22H63.244V.852A.851.851,0,0,0,62.395,0H16.672a.644.644,0,0,0-.112.025.525.525,0,0,0-.1.021.836.836,0,0,0-.39.2L5.147,11.173a.863.863,0,0,0-.207.386c-.011.035-.014.07-.021.105s-.021.074-.021.112V22H.853A.852.852,0,0,0,0,22.85V62.394a5.758,5.758,0,0,0,5.75,5.75H62.395a5.757,5.757,0,0,0,5.747-5.75V22.85a.851.851,0,0,0-.85-.853M11.813,6.915l4.006-4.006v8.015H7.8ZM5.75,66.441A4.054,4.054,0,0,1,1.7,62.394V23.7H19.744l4.079,5.213a.857.857,0,0,0,.671.326h32.15V62.394a.867.867,0,0,0,.011.095l-.011.049a1.042,1.042,0,0,0,.028.144,5.722,5.722,0,0,0,1.643,3.76ZM57.494,27.533H24.908l-4.079-5.21A.847.847,0,0,0,20.158,22H6.6v-9.37H16.672a.851.851,0,0,0,.853-.85V1.705H61.542V61.685H58.347v-33.3a.854.854,0,0,0-.853-.853m8.945,34.861a4.038,4.038,0,0,1-7.955.994h3.911a.848.848,0,0,0,.85-.85l-.007-.042.007-.039V23.7h3.195Z",
    transform: "translate(0 -0.004)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60334",
    "data-name": "Path 60334",
    d: "M14.985,14.045a.886.886,0,0,0-1.464,0L5.387,27.729a.852.852,0,0,0,.734,1.288H22.389a.849.849,0,0,0,.73-1.288Zm-.73,2.1,2.352,3.96-.678-.137a.846.846,0,0,0-.716.183l-.958.8-.958-.8a.849.849,0,0,0-.716-.183l-.681.137ZM7.617,27.315l3.11-5.231,1.787-.362,1.194,1a.845.845,0,0,0,1.092,0l1.194-1,1.79.362,3.107,5.231Z",
    transform: "translate(13.226 34.289)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60335",
    "data-name": "Path 60335",
    d: "M26.611,14.22c-.007-.032-.028-.06-.035-.091a.84.84,0,0,0-.063-.154.617.617,0,0,0-.095-.14.556.556,0,0,0-.1-.105.867.867,0,0,0-.161-.109.785.785,0,0,0-.312-.088.561.561,0,0,0-.074-.018c-.025,0-.046.014-.07.014s-.053,0-.077,0l-9.247,1.615a.6.6,0,0,0-.084.032,1.148,1.148,0,0,0-.165.063,1.083,1.083,0,0,0-.13.091.85.85,0,0,0-.116.109.929.929,0,0,0-.091.137.673.673,0,0,0-.067.144.893.893,0,0,0-.032.169.751.751,0,0,0-.021.095v7.741a3.088,3.088,0,0,0-.607-.084,4.041,4.041,0,0,0-2.3.671c-1.622,1.025-2.282,2.794-1.5,4.027a2.367,2.367,0,0,0,1.987,1.039h.112a4.155,4.155,0,0,0,2.184-.671,4.075,4.075,0,0,0,1.587-1.783,2.685,2.685,0,0,0,.232-1.218l.011-.042v-6.5l7.541-1.316v3.862a2.848,2.848,0,0,0-.611-.084,3.914,3.914,0,0,0-2.292.667c-1.622,1.025-2.282,2.794-1.506,4.027A2.374,2.374,0,0,0,22.5,27.356c.035,0,.074,0,.109,0a4.177,4.177,0,0,0,2.184-.671,4.133,4.133,0,0,0,1.59-1.787,2.631,2.631,0,0,0,.207-1.366.857.857,0,0,0,.032-.165v-9a.5.5,0,0,0-.014-.07.569.569,0,0,0,0-.077M15.573,26.244a2.645,2.645,0,0,1-2.264,1.429.772.772,0,0,1-.6-.246c-.2-.309.088-1.116.972-1.678a2.493,2.493,0,0,1,1.274-.407H15a.792.792,0,0,1,.607.246v0a.767.767,0,0,1-.039.653m9.247-2.019a2.645,2.645,0,0,1-2.264,1.429.772.772,0,0,1-.6-.246c-.2-.309.084-1.116.972-1.678a2.493,2.493,0,0,1,1.274-.407h.053c.137.007.474.039.6.246l0,0a.78.78,0,0,1-.039.653m.1-8.106-7.541,1.316v-.741l7.541-1.313Z",
    transform: "translate(27.464 33.928)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60336",
    "data-name": "Path 60336",
    d: "M8.178,4.815H39.107a.851.851,0,0,0,0-1.7H8.178a.851.851,0,1,0,0,1.7",
    transform: "translate(18.39 7.812)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60337",
    "data-name": "Path 60337",
    d: "M47.034,5.541a.854.854,0,0,0-.853-.853H5.359a.853.853,0,1,0,0,1.706H46.181a.854.854,0,0,0,.853-.853",
    transform: "translate(11.313 11.769)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60338",
    "data-name": "Path 60338",
    d: "M39.1,6.266H8.176a.851.851,0,0,0,0,1.7H39.1a.851.851,0,0,0,0-1.7",
    transform: "translate(18.393 15.731)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60339",
    "data-name": "Path 60339",
    d: "M13.349,19.978,3.926,13.9A1.638,1.638,0,0,0,1.4,15.274V27.445a1.64,1.64,0,0,0,2.531,1.376l9.423-6.087a1.643,1.643,0,0,0,0-2.756M3.1,27.329,3,15.326,12.422,21.3Z",
    transform: "translate(3.502 34.222)",
    fill: "#ec431f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultimedia);
export default __webpack_public_path__ + "static/media/multimedia.118766347054aa1cd8c20860c56e228f.svg";
export { ForwardRef as ReactComponent };